import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withAuthorization } from '../../../shared/services/auth/with-authorization/with-authorization.component';
import {
  resolveRoleDashboard,
  ROLE_DASHBOARD_PERMITTED_ROLES
} from '../../shared/config/role-dashboard.config';
import { AdminDashboard } from './components/admin-dashboard.component';
import { TeamDashboard } from './components/team-dashboard.component';

export const RoleDashboardContainer = () => {
  const dashboard = useMemo(resolveRoleDashboard, []);

  if (dashboard.kind === 'redirect') {
    return <Redirect to={dashboard.path} />;
  }

  return (
    <div className="min-h-[calc(100vh-45px)] w-full bg-white px-[clamp(16px,3vw,48px)] pb-20 pt-8">
      <div className="mx-auto max-w-[1440px]">
        {dashboard.kind === 'admin' ? (
          <AdminDashboard superAdmin={dashboard.superAdmin} />
        ) : (
          <TeamDashboard
            goals={dashboard.goals}
            verticals={dashboard.verticals}
            panels={dashboard.panels}
          />
        )}
      </div>
    </div>
  );
};

export default connect()(
  withAuthorization(ROLE_DASHBOARD_PERMITTED_ROLES, true)(RoleDashboardContainer)
);
